import { Box, Paper, Typography } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";
import { Button, PageHeader } from "@components/ui_v2";
import useSignOut from "@hooks/useSignOut";

/** Recomendaciones para una próxima solicitud: aplican a crédito, arrendamiento y cualquier producto. */
const RECOMENDACIONES = [
  "Mantén al corriente tus declaraciones ante el SAT y tus pagos de créditos vigentes.",
  "Conserva tus estados de cuenta y tu declaración anual más reciente.",
  "Puedes volver a solicitar en 3 meses con tu información actualizada.",
];

/**
 * Resultado negativo de la solicitud (status `CSREC` / `CSRER`). Basada en `S_MCRechazo` del diseño, con
 * el texto sin mencionar el producto para que sirva a cualquier empresa (crédito, arrendamiento, etc.).
 * "Salir" cierra la sesión, como el legacy `tofu/pm/Rechazo`.
 */
export const CreditoRechazado = () => {
  const { signOutAndRedirect, isSigningOut } = useSignOut();

  return (
    <Box>
      <PageHeader
        eyebrow="Resultado de tu solicitud"
        title="Por el momento no podemos ayudarte"
        subtitle="Gracias por considerarnos. Revisamos tu información con cuidado y, por ahora, no nos es posible ofrecerte el financiamiento que solicitaste. Esta respuesta no es definitiva: tu situación puede cambiar y con gusto volveremos a revisarla."
      />

      <Paper variant="lendia_paper">
        <Typography variant="body1" sx={{ fontWeight: 600, color: "primary.dark" }}>
          Lo que puede ayudarte en una próxima solicitud
        </Typography>
        <Box
          component="ul"
          sx={{ listStyle: "none", p: 0, m: "12px 0 0", display: "flex", flexDirection: "column", gap: 1.25 }}
        >
          {RECOMENDACIONES.map((texto) => (
            <Box component="li" key={texto} sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
              <CheckCircleOutline sx={{ fontSize: 16, mt: "2px", color: "success.main", flexShrink: 0 }} />
              <Typography variant="body2" color="tokens.textSecondary" sx={{ lineHeight: 1.5 }}>
                {texto}
              </Typography>
            </Box>
          ))}
        </Box>
      </Paper>

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <Button onClick={signOutAndRedirect} disabled={isSigningOut} data-testid="credito-rechazado-salir-button">
          Salir
        </Button>
      </Box>
    </Box>
  );
};
